﻿import { Button, FormatText, FormInput, FormSubmitButton, MasterDetailForm, Row, Widget } from '@digital/ui';
import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { newGuid } from '../../../helpers/geradorGuid';



interface PropsModal {
  onUpdate: any;
}

const ModalCreateResposta = (props: PropsModal) => {
  const { onUpdate } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const [valorInicial, setValorInicial] = useState({ descricao: '', idFake: newGuid() });

  const handleSubmit = (values: any) => {
    onUpdate(values);
    setExibirModal(false);
  };

  useEffect(() => {
    setValorInicial({ descricao: '', idFake: newGuid() });
  }, [exibirModal]);

  useEffect(() => {
    const imputDescricao = document.getElementById('descricaoResposta');
    if (imputDescricao != null) {
      imputDescricao.value = '';
    }
  }, [exibirModal]);

  return (
    <>
      <Row>
        <Button
          onClick={() => {
            setExibirModal(true);
          }}>
          ADICIONAR RESPOSTA
        </Button>
      </Row>
      <Modal
        title="RESPOSTA"
        width="1200px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          validationSchema={Yup.object().shape({
            descricao: Yup.string().required('Resposta deve ser informada.'),
          })}
          initialValues={valorInicial}
          key="formTemplate"
          onSubmit={handleSubmit}
          actions={[
            <Button
              key="close"
              type="link"
              onClick={() => {
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton key="save" noIcon type="primary">
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <Row style={{ margin: '0px' }}>
              <FormInput name="descricao" label="Resposta" span={8} defaultValue={''} id={'descricaoResposta'} />
            </Row>
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};

export default ModalCreateResposta;
